import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { CheckCircle, XCircle, ArrowClockwise } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts.current >= 6) { setStatus("timeout"); return; }
        attempts.current += 1;
        setTimeout(poll, 2000);
      } catch (e) {
        setStatus("error");
      }
    };
    poll();
  }, [params]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24 pb-16 max-w-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {status === "checking" && (
          <>
            <ArrowClockwise size={48} className="mx-auto text-brand animate-spin mb-4" />
            <h1 className="font-display text-3xl mb-2">Processing payment…</h1>
            <p className="text-slate-600">Hang tight, we&apos;re confirming with Stripe.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle size={64} weight="fill" className="mx-auto text-brand mb-4" />
            <h1 className="font-display text-4xl mb-2">Payment successful</h1>
            <p className="text-slate-600 mb-6">
              You paid {info?.amount_total ? `$${(info.amount_total / 100).toFixed(2)} ${info?.currency?.toUpperCase()}` : ""}. Your plan is active.
            </p>
            <Link to="/dashboard" className="inline-block bg-brand text-white px-6 py-3 font-semibold" data-testid="back-to-dashboard">Back to dashboard</Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <XCircle size={64} weight="fill" className="mx-auto text-accent-red mb-4" />
            <h1 className="font-display text-3xl mb-2">{status === "timeout" ? "Still processing" : "Payment issue"}</h1>
            <p className="text-slate-600 mb-6">Please check your email or try again from the pricing page.</p>
            <Link to="/pricing" className="inline-block bg-slate-900 text-white px-6 py-3 font-semibold">Try again</Link>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
